export const APP_URL = 'https://app.callerdesk.io/';
export const BASE_URL = 'https://app.callerdesk.io/api/';
export const BASE_URL_V2 = 'https://app.callerdesk.io/api_v2/';
export const dummy_user = 'https://placeimg.com/640/480/people';

export const urls = {
    logout: `${BASE_URL}logout`,
    todayWorkSummary: `${BASE_URL}get-count-v2`,
    calllogV2: `${BASE_URL}call_list_v2`,
    clickToCall: `${BASE_URL}click_to_call_agentwise`,
    updateWorkingStatus: `${BASE_URL}update-working-status-v3`,
    liveCall: `${BASE_URL}live_call_v2`,
    loginV2: `${BASE_URL_V2}signin`,
    status  : `${BASE_URL}changeagentstatus`,
    calltocustomer: `${BASE_URL}click_to_call_v2`,
    socket: "https://www.apibuild.callerdesk.io",
    disconnect : `${BASE_URL}call_disconnect`   

};


export const SetLocalStorage = (key: string, value: any) => {
    localStorage.setItem(key, JSON.stringify(value));
};
export const GetLocalStorage = (key: string) => {
    return localStorage.getItem(key);
};
export const RemoveLocalStorage = (key: string) => {
    localStorage.removeItem(key);
};
